import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import { getRating } from '@/helpers/statusIncident.js';
import TicketItem from '@/components/request/elements/TicketItem/TicketItem.vue';
import TicketCommentsRich from '@/components/request/elements/TicketCommentsRich';
import { getIncidentStatus } from '@/helpers/statusIncident.js';
import { showError } from '@/helpers/globalHelpers';
import RatingDialog from '@/components/request/elements/RatingDialog/RatingDialog.vue';
import ReassignUserDialog from '../../request/elements/ReassignUserDialog';
import TicketDetailElement from '@/components/request/elements/TicketDetailElement/TicketDetailElement.vue';
import HtmlViewer from '@/components/global/HtmlViewer';

export default {
	name: 'TicketConfirm',
	data() {
		return {
			signedEvidences: {},
			loadingEvidences: {},
			reassignUserDialog: false,
			source: 'request-detail',
			statusList: [
				{ text: 'Solicitado', value: 'Solicitado' },
				{ text: 'Asignado', value: 'Asignado' },
				{ text: 'Resolución', value: 'Resolución' },
				{ text: 'Consulta', value: 'Consulta' },
				{ text: 'Cerrado', value: 'Cerrado' },
			],
			loading: false,
			filters: {
				q: null,
				page: 1,
				area: null,
				status: null,
				pagination: true,
				per_page: process.env.VUE_APP_PAGINATION_PER_PAGE || 10,
			},
			// mode: 'REQUEST', // TICKETSTARTED,REQUEST
			isRatingActive: false,
		};
	},

	created() {
		this.getRequestId();
		this.getResponsibles();
	},

	computed: {
		breadcrumbs() {
			const type = this.$route.query.type || 'incident';

			return [
				{
					text: 'Inicio',
					link: true,
					exact: true,
					disabled: false,
					to: { name: 'Dashboard' },
				},
				{
					text: 'Incidentes',
					link: true,
					exact: true,
					disabled: false,
					to: { name: 'IncidentsHome' },
				},
				{
					text: 'Tickets',
					link: true,
					exact: true,
					disabled: false,
					to: { name: type === 'request' ? 'RequestList' : 'IncidentList' },
				},
				{
					text: 'Detalle de Ticket',
					link: true,
					exact: true,
					disabled: true,
				},
			];
		},

		...mapState('ticket', ['ticket']),
		...mapState('auth', ['user']),
		hasStartTicketPermission() {
			return this.$store.getters['auth/hasActivity'](
				'solicitudes',
				'detalleSolicitud',
				'iniciarTicket'
			);
		},
		hasCommentPermission() {
			return this.$store.getters['auth/hasActivity'](
				'solicitudes',
				'detalleSolicitud',
				'escribirComentarios'
			);
		},
		isColumns() {
			return (
				this.ticket?.ticket_attention &&
				!['SOLICITADO', 'CANCELADO'].includes(this.ticket?.status)
			);
		},
		showDetailTicketConfirm() {
			if (
				this.ticket &&
				this.user &&
				this.ticket?.ticket_user_confirm?.some(
					(ticketUserConfirm) =>
						ticketUserConfirm?.user_confirm.id === this.user.id ||
						ticketUserConfirm?.user_confirm === this.user.id
				)
			) {
				return true;
			} else {
				return false;
			}
		},

		ticketUserConfirm() {
			if (this.ticket) {
				const [userconfirm] = this.ticket?.ticket_user_confirm;
				return userconfirm;
			}
		},
	},

	methods: {
		getIncidentStatus,
		...mapActions('user', ['getResponsibles']),
		...mapActions('ticket', ['getTicketById', 'cleanTicket', 'ticketConfirm','declinedTicket']),
		...mapActions('ticketAttention', ['createTicketAttention']),

		...mapActions('assetAssignment', ['signedFileURl']),

		async getEvidenceSigned(evidenceId, evidenceFile) {
			if (this.signedEvidences[evidenceId]) {
				return this.signedEvidences[evidenceId];
			}

			this.$set(this.loadingEvidences, evidenceId, true);

			const { error, response, ok } = await this.signedFileURl({
				data: { fileUrl: evidenceFile },
			});

			if (ok) {
				this.$set(this.signedEvidences, evidenceId, response.signedUrl);
				this.$set(this.loadingEvidences, evidenceId, false);
				return response.signedUrl;
			} else {
				showError(error);
				this.$set(this.loadingEvidences, evidenceId, false);
				return null;
			}
		},

		async openPreviewDialog(evidenceId, evidenceFile) {
			this.$set(this.loadingEvidences, evidenceId, true);

			const signedUrl = await this.getEvidenceSigned(evidenceId, evidenceFile);
			const fileUrl = signedUrl || evidenceFile;
			const fileType = this.getFileExtension(evidenceFile);
			const fileName = this.getFileName(evidenceFile);

			if (this.isImageFile(fileType)) {
				this.openImageInNewTab(fileUrl, fileName);
				this.$set(this.loadingEvidences, evidenceId, false);
				return;
			}

			if (this.isPdfFile(fileType)) {
				this.openPdfInNewTab(fileUrl, fileName);
				this.$set(this.loadingEvidences, evidenceId, false);
				return;
			}

			let previewUrl;
			if (this.isOfficeFile(fileType)) {
				previewUrl = this.getOfficePreviewUrl(fileUrl);
			} else {
				previewUrl = fileUrl;
			}

			window.open(previewUrl, '_blank');
			this.$set(this.loadingEvidences, evidenceId, false);
		},

		async openPdfInNewTab(pdfUrl, fileName) {
			let embedUrl = null;
			let downloadUrl = pdfUrl;
			try {
				const response = await fetch(pdfUrl);
				if (response.ok) {
					const blob = await response.blob();
					const pdfBlob = new Blob([blob], { type: 'application/pdf' });
					embedUrl = URL.createObjectURL(pdfBlob);
					downloadUrl = embedUrl;
				}
			} catch (e) {
				embedUrl = null;
			}

			if (!embedUrl) {
				embedUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`;
			}

			const htmlContent = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>${fileName}</title><style>*{margin:0;padding:0;box-sizing:border-box}html,body{height:100vh;background-color:#1a1a1a;display:flex;flex-direction:column}.header{background-color:#2d2d2d;padding:12px 20px;display:flex;justify-content:space-between;align-items:center;color:white;font-family:Arial,sans-serif}.header h1{font-size:16px;font-weight:normal;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:70%}.download-btn{background-color:#0039a6;color:white;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;font-size:14px;text-decoration:none}.download-btn:hover{background-color:#002d7a}.pdf-container{flex:1;display:flex}.pdf-container iframe{flex:1;width:100%;height:100%;border:none}</style></head><body><div class="header"><h1>${fileName}</h1><a href="${downloadUrl}" download="${fileName}" class="download-btn">Descargar</a></div><div class="pdf-container"><iframe src="${embedUrl}" type="application/pdf"></iframe></div></body></html>`;

			const blob = new Blob([htmlContent], { type: 'text/html' });
			window.open(URL.createObjectURL(blob), '_blank');
		},

		openImageInNewTab(imageUrl, fileName) {
			const htmlContent = `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><title>${fileName}</title><style>*{margin:0;padding:0;box-sizing:border-box}body{background-color:#1a1a1a;min-height:100vh;display:flex;flex-direction:column}.header{background-color:#2d2d2d;padding:12px 20px;display:flex;justify-content:space-between;align-items:center;color:white;font-family:Arial,sans-serif}.header h1{font-size:16px;font-weight:normal;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:70%}.download-btn{background-color:#0039a6;color:white;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;font-size:14px;text-decoration:none}.download-btn:hover{background-color:#002d7a}.image-container{flex:1;display:flex;justify-content:center;align-items:center;padding:20px;overflow:auto}.image-container img{max-width:100%;max-height:calc(100vh - 80px);object-fit:contain}</style></head><body><div class="header"><h1>${fileName}</h1><a href="${imageUrl}" download="${fileName}" class="download-btn">Descargar</a></div><div class="image-container"><img src="${imageUrl}" alt="${fileName}" /></div></body></html>`;
			const blob = new Blob([htmlContent], { type: 'text/html' });
			window.open(URL.createObjectURL(blob), '_blank');
		},

		isImageFile(extension) {
			return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension?.toLowerCase());
		},

		isPdfFile(extension) {
			return extension?.toLowerCase() === 'pdf';
		},

		isOfficeFile(extension) {
			return ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension?.toLowerCase());
		},

		getOfficePreviewUrl(fileUrl) {
			return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;
		},

		getFileName(url) {
			if (!url) return 'Archivo';
			try {
				const urlObj = new URL(url);
				let filename = decodeURIComponent(urlObj.pathname.split('/').pop());
				filename = filename.replace(/^\d+-/, '');
				return filename || 'Archivo';
			} catch {
				return 'Archivo';
			}
		},

		getFileExtension(url) {
			if (!url) return '';
			const filename = this.getFileName(url);
			const parts = filename.split('.');
			return parts.length > 1 ? parts.pop().toLowerCase() : '';
		},

		getFileIcon(url) {
			const ext = this.getFileExtension(url);
			const map = {
				jpg: 'mdi-file-image', jpeg: 'mdi-file-image', png: 'mdi-file-image',
				gif: 'mdi-file-image', bmp: 'mdi-file-image', webp: 'mdi-file-image', svg: 'mdi-file-image',
				pdf: 'mdi-file-pdf-box',
				doc: 'mdi-file-word', docx: 'mdi-file-word',
				xls: 'mdi-file-excel', xlsx: 'mdi-file-excel', csv: 'mdi-file-excel',
				ppt: 'mdi-file-powerpoint', pptx: 'mdi-file-powerpoint',
				txt: 'mdi-file-document-outline',
				zip: 'mdi-folder-zip', rar: 'mdi-folder-zip', '7z': 'mdi-folder-zip',
				mp4: 'mdi-file-video', avi: 'mdi-file-video', mov: 'mdi-file-video', wmv: 'mdi-file-video',
				mp3: 'mdi-file-music', wav: 'mdi-file-music',
			};
			return map[ext] || 'mdi-file-outline';
		},

		getFileIconColor(url) {
			const ext = this.getFileExtension(url);
			const map = {
				jpg: '#9C27B0', jpeg: '#9C27B0', png: '#9C27B0', gif: '#9C27B0',
				bmp: '#9C27B0', webp: '#9C27B0', svg: '#9C27B0',
				pdf: '#F44336',
				doc: '#2196F3', docx: '#2196F3',
				xls: '#4CAF50', xlsx: '#4CAF50', csv: '#4CAF50',
				ppt: '#FF9800', pptx: '#FF9800',
				zip: '#795548', rar: '#795548', '7z': '#795548',
				mp4: '#E91E63', avi: '#E91E63', mov: '#E91E63', wmv: '#E91E63',
				mp3: '#00BCD4', wav: '#00BCD4',
			};
			return map[ext] || 'primary';
		},

		getRating,
		changeFilter() {},

		...mapActions('ticketComment', ['listTicketComments']),

		async getTicketComments() {
			const payload = {
				company_id: this.ticket?.company_id,
				ticket_attention: this.ticket?.ticket_attention.id,
			};
			const { error } = await this.listTicketComments(payload);
			if (error) {
				showError(error);
			}
		},

		confirmTicket() {
			this.$swal({
				icon: 'question',
				title: 'Confirmación de Ticket',
				text: '¿Estás seguro de que deseas confirmar este ticket?',
				showCancelButton: true,
				confirmButtonText: 'Sí, confirmar',
				cancelButtonText: 'Cancelar',
				confirmButtonColor: '#0039a6',
				cancelButtonColor: 'grey',
			}).then(async (result) => {
				if (result.isConfirmed) {
					// Iniciar Ticket / Crear Ticket-Attention
					await this.confirmedTicket();
					// this.mode = 'TICKETSTARTED';
				}
			});
		},

		declineTicket() {
			this.$swal({
				icon: 'question',
				title: 'Confirmación de Ticket',
				text: '¿Estás seguro de que deseas desaprobar este ticket?',
				input: 'textarea',
				inputPlaceholder: 'Escribe el motivo del rechazo...',
				showCancelButton: true,
				confirmButtonText: 'Sí, desaprobar',
				cancelButtonText: 'Cancelar',
				confirmButtonColor: '#0039a6',
				cancelButtonColor: 'grey',
				preConfirm: async (comment) => {
					if (!comment || !comment.trim()) {
						this.$swal.showValidationMessage('Debes ingresar un comentario');
						return false;
					}
		
					this.$swal.showLoading();
		
					try {
						await this.disapproveTicket(comment);
					} catch (err) {
						console.error(err);
						this.$swal.showValidationMessage('Error al desaprobar el ticket');
					}
				}
			});
		},

		async getRequestId() {
			try {
				this.loading = true;
				const id = this.$route.params.incidentId;
				await this.getTicketById(id);
				this.loading = false;
			} catch (ex) {
				console.log(ex);
			}
		},

		async confirmedTicket() {
			const { ok, error } = await this.ticketConfirm(this.ticket.id);
			if (ok) {
				window.location.reload();
				// await this.getTicketComments();
				// this.getRequestId();
			} else {
				showError(error);
			}
		},

		async disapproveTicket(comment){
			const { ok, error } = await this.declinedTicket({id:this.ticket.id, data:{description:comment}});
			if (ok) {
				window.location.reload();
			} else {
				showError(error);
			}
		},

		formatDate(dateString) {
			if (!dateString) {
				return '-';
			}
			return moment(dateString).format('DD/MM/YYYY HH:mm');
		},

		downloadFile(filePath) {
			const fileName = filePath.split('/').pop();
			let a = document.createElement('a');
			a.href = filePath;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		},
		printSubtype(item) {
			return (
				item?.subtype?.classification?.area?.name +
				' / ' +
				item?.subtype?.classification?.name +
				' / ' +
				item?.subtype?.name
			);
		},
		printAssets(assets) {
			let assetsText = [];
			if (Array.isArray(assets)) {
				assets.forEach((asset) => {
					assetsText.push(asset?.name + ' ' + asset?.serial_number);
				});
			}
			return assetsText.join(', ');
		},

		setTicketStatus(value) {
			this.ticket.status = value;
		},

		getNamefile(url) {
			try {
				const urlParts = url.split('/');
				const fileNameWithTimestamp = urlParts[urlParts.length - 1];
				const fileNameParts = fileNameWithTimestamp.split('-');
				fileNameParts.shift();
				const fileName = fileNameParts.join('-');
				return fileName;
			} catch (error) {
				return 'EVIDENCIA';
			}
		},

		reassignUser() {
			//this.item = Object.assign({}, request);
			this.reassignUserDialog = true;
			this.$nextTick(() => {
				document.activeElement.blur();
			});
		},
	},
	beforeDestroy() {
		this.cleanTicket();
	},
	components: {
		TicketItem,
		TicketComments: TicketCommentsRich,
		RatingDialog,
		ReassignUserDialog,
		TicketDetailElement,
		HtmlViewer,
	},
};
